import { PropsWithChildren } from "react";
import { StudentFormData, useStudentForm } from "../StudentDataFormProvider";
import { Stack, styled, Typography } from "@mui/material";

type Option<TOption> = {
  label: string;
  value: TOption;
};

type Props<TValue> = {
  fieldName: keyof StudentFormData;
  label?: string;
  options: Option<TValue>[];
  required?: boolean;
};

export const DropdownField = <TValue extends string | number | readonly string[] | undefined>({
  fieldName,
  label,
  options,
  required = false,
}: PropsWithChildren<Props<TValue>>) => {
  const {
    register,
    formState: { errors },
  } = useStudentForm();
  return (
    <Stack gap={"0.25rem"} sx={{ width: "100%" }}>
      {label && <label htmlFor={fieldName}>{label}</label>}
      <StyledDropdown {...register(fieldName, { required })}>
        {options.map((o) => (
          <StyledOption value={o.value} key={o.label}>
            {o.label}
          </StyledOption>
        ))}
      </StyledDropdown>
      {errors[fieldName] && (
        <Typography variant="caption" sx={{ color: "red" }}>
          This field is required
        </Typography>
      )}
    </Stack>
  );
};

const StyledDropdown = styled("select")({
  borderRadius: "0.5rem",
  padding: "0.5rem",
  border: "1px solid #cbcbcb",
  fontSize: "1rem",
});

const StyledOption = styled("option")({
  padding: "0.5rem",
  border: "1px solid #cbcbcb",
  fontSize: "1rem",
});
